import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrea Antonello
 * id A1B2C0E5-8F8A-40B8-8EE4-A619DE840E9A
 * name vector-point-minus
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-point-minus.svg
 * tags
 * - Vector 
 */
export const VectorPointMinusIcon = createSvgIcon(<><path d="M9 9V15H15V9H9M11 11H13V13H11V11M15 18V20H23V18H15Z" /></>, 'VectorPointMinusIcon');
export default VectorPointMinusIcon